module.exports = __webpack_public_path__ + "static/img/manual_ja_38.f76946d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_38.png
// module id = 5Muz
// module chunks = 4